import { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import GoldRateDropdown from "./GoldRateDropdown/GoldRateDropdown";
import SilverRateDropdownComponent from "./SilverRateDropdown/SilverRateDropdown";

export default function Header() {
  const [isMenuClicked, setIsMenuClicked] = useState(false);
  const navigate = useNavigate();

  const handleMenu = () => {
    setIsMenuClicked(!isMenuClicked);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 938);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 938);
      if (window.innerWidth > 938) {
        setIsMenuClicked(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const rateBoxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "180px",
    height: "50px",
    gap: "5px",
    fontFamily: "Times New Roman, Times, serif"
  };

  const mobileRateBoxStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "30px",
    gap: "3px",
    fontFamily: "Times New Roman, Times, serif",
    fontSize: "12px"
  };

  return (
    <div className="headerContainer" style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      padding: '10px',
      fontFamily: 'Times New Roman, Times, serif',
      backgroundColor: '#000',
      color: '#fff',
      position: 'relative',
      marginBottom: '0',
      paddingBottom: '0'
    }}>
      <div className="logoContainer" onClick={() => navigate('/')} style={{
        display: 'flex',
        alignItems: 'center',
        flexShrink: 0
      }}>
        <img
          src="./assets/logo-vm.webp"
          alt="Logo"
          style={{
            width: isMobile ? '40px' : '50px',
            height: isMobile ? '40px' : '50px',
            borderRadius: '50%',
            marginRight: '10px'
          }}
        />
        <h2
          className="text-white"
          style={{
            fontSize: isMobile ? '18px' : '24px',
            whiteSpace: isMobile ? 'normal' : 'nowrap',
            width: isMobile ? '120px' : '300px',
            lineHeight: isMobile ? '1.2' : '1.5',
            display: 'flex',
            flexDirection: isMobile ? 'column' : 'row',
            alignItems: 'center'
          }}
        >
          <span>Vairamaaligai {isMobile || <span style={{ fontSize: '24px' }}> Jewellery</span>}</span>

          {isMobile && <span style={{ fontSize: '16px' }}>Jewellery</span>}
        </h2>
      </div>

      {isMobile && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '5px',
          marginLeft: 'auto',
          marginRight: '10px'
        }}>
          <div style={mobileRateBoxStyle}>
            <GoldRateDropdown mobile />
          </div>
          <div style={mobileRateBoxStyle}>
            <SilverRateDropdownComponent mobile />
          </div>
        </div>
      )}

      {isMobile ? (
        <div
          className="menuToggle"
          onClick={handleMenu}
          style={{
            cursor: 'pointer',
            fontSize: '24px',
            padding: '5px'
          }}
        >
          {isMenuClicked ? '✕' : '☰'}
        </div>
      ) : (
        <div className="centerContainer" style={{
          display: 'flex',
          alignItems: 'center',
          gap: '20px',
          marginLeft: 'auto'
        }}>
          <div className="GoldRateContainer" style={{ display: 'flex', gap: '10px' }}>
            <div style={rateBoxStyle}>
              <GoldRateDropdown />
            </div>
            <div style={rateBoxStyle}>
              <SilverRateDropdownComponent />
            </div>
          </div>

          <div className="navbarIcons" style={{ display: 'flex', gap: '15px' }}>
            <NavLink to="home" className="NavItem">Home</NavLink>
            <NavLink to="/about" className="NavItem">About</NavLink>
            <NavLink to="contact" className="NavItem">Contact</NavLink>
          </div>
        </div>
      )}

      {isMobile && isMenuClicked && (
        <div className="mobileMenu" style={{
          position: 'absolute',
          top: '100%',
          left: 0,
          right: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.9)',
          padding: '15px',
          zIndex: 1000,
          display: 'flex',
          flexDirection: 'column',
          gap: '15px',
          alignItems: 'center'
        }}>
          <NavLink
            to="home"
            className="NavItem"
            onClick={handleMenu}
            style={{ color: '#fff', textDecoration: 'none', fontSize: '18px' }}
          >
            Home
          </NavLink>
          <NavLink
            to="/about"
            className="NavItem"
            onClick={handleMenu}
            style={{ color: '#fff', textDecoration: 'none', fontSize: '18px' }}
          >
            About
          </NavLink>
          <NavLink
            to="/contact"
            className="NavItem"
            onClick={handleMenu}
            style={{ color: '#fff', textDecoration: 'none', fontSize: '18px' }}
          >
            Contact
          </NavLink>
        </div>
      )}
    </div>
  );
}